class ErrorActions {

    static buttonEnable = "BUTTON_ENABLE";
    static buttonDisable = "BUTTON_DISABLE";

    
    static ButtonDisable(data) {
        return {
            type : this.buttonDisable,
        }
    }

    static ButtonEnable(data) {
        return {
            type : this.buttonEnable,
        }
    }
}

export default ErrorActions;


// WEBPACK FOOTER //
// ./src/store/actions/errorActions.js